const canCreateSubscriptionCheckoutSession = (products) => {
  if (!products || Object.keys(products).length === 0) {
    return false;
  }

  const hasMembershipQty = Object.values(products).some((q) => q > 0);

  return hasMembershipQty;
};

export default canCreateSubscriptionCheckoutSession;
